import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { AlertCircle, Clock, CheckCircle, ArrowRight } from 'lucide-react';

const Dashboard = () => {
  const [summary, setSummary] = useState(null);
  const [taskSummary, setTaskSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [poRes, taskRes] = await Promise.all([
          api.get('/po-lines/summary'),
          api.get('/tasks/summary')
        ]);
        setSummary(poRes.data);
        setTaskSummary(taskRes.data);
      } catch (err) {
        console.error('Failed to fetch dashboard data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <div className="loading"><div className="spinner" /></div>;
  }

  return (
    <div>
      <h1 className="mb-6" style={{ fontSize: '1.5rem', fontWeight: '600' }}>Dashboard</h1>
      
      {/* Stats Grid */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Open POs</div>
          <div className="stat-value">{summary?.totalOpen || 0}</div>
          {summary?.debug && (
            <div className="text-xs text-muted mt-1">
              (Total in DB: {summary.debug.totalRecords})
            </div>
          )}
        </div>
        
        <div className="stat-card">
          <div className="stat-label">Past Due</div>
          <div className="stat-value danger">{summary?.pastDueCount || 0}</div>
        </div>
        
        <div className="stat-card">
          <div className="stat-label">Pending Tasks</div>
          <div className="stat-value">{taskSummary?.byStatus?.pending || 0}</div>
        </div>
        
        <div className="stat-card">
          <div className="stat-label">Completed Today</div>
          <div className="stat-value success">{taskSummary?.byStatus?.completed || 0}</div>
        </div>
      </div>

      {/* Response Status Summary */}
      <div className="card mb-4">
        <div className="card-header">
          <h2 className="card-title">PO Lines by Response Status</h2>
          <Link to="/po-lines" className="btn btn-outline btn-sm">
            View All <ArrowRight size={14} />
          </Link>
        </div>
        <div className="card-body">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px' }}>
            {Object.entries(summary?.byResponseStatus || {}).map(([status, count]) => (
              <div key={status} style={{ 
                padding: '12px', 
                background: 'var(--bg-secondary)', 
                borderRadius: 'var(--radius)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span className="text-sm">{status.replace(/_/g, ' ')}</span>
                <span className="font-medium">{count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Quick Actions</h2>
        </div>
        <div className="card-body">
          <div className="flex gap-4">
            <Link to="/po-lines?filter=pastDue" className="btn btn-outline">
              <AlertCircle size={16} />
              View Past Due POs
            </Link>
            <Link to="/tasks?status=pending" className="btn btn-outline">
              <Clock size={16} />
              Pending Tasks
            </Link>
            <Link to="/chat" className="btn btn-primary">
              <CheckCircle size={16} />
              Open Chat Assistant
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;